import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PillSpinner from '../components/PillSpinner';

const API_URL = 'http://localhost:5000/api';

const SalesHistory = () => {
  const [sales, setSales] = useState([]);
  const [medicines, setMedicines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [salesRes, medsRes] = await Promise.all([
          axios.get(`${API_URL}/sales`),
          axios.get(`${API_URL}/medicines`)
        ]);
        setSales(salesRes.data);
        setMedicines(medsRes.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Helper function to get medicine name from ID
  const getMedicineName = (medicineId) => {
    const medicine = medicines.find(m => m._id === medicineId);
    return medicine ? medicine.name : 'Unknown Medicine';
  };

  if (loading) return <PillSpinner />;

  return (
    <div className="card">
      <h2>📜 Sales History</h2>
      <table className="inventory-table sales-history-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Medicine Name</th>
            <th>Quantity</th>
            <th>Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {sales.map(sale => (
            <tr key={sale._id}>
              <td>{new Date(sale.date).toLocaleString()}</td>
              <td title={sale.medicineId}>{getMedicineName(sale.medicineId)}</td>
              <td>{sale.quantitySold}</td>
              <td>₹{sale.amount.toFixed(2)}</td>
            </tr>
          ))}
          {sales.length === 0 && (
            <tr>
              <td colSpan="4">No sales recorded yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SalesHistory;